export const MESSAGING_ROUTES = {
	messaging: "/app/messaging",
} as const;
